import React from "react";

import Layout from "../Layout";
import Carousel from "./Carousel";
import * as UI from "./ui";

const FlashContestWinnerSection = ({ sweepstakes }) => {
  const flashContests = sweepstakes.pastFlashContests;
  if(flashContests.length === 0) {
    return null;
  }

  return (
    <React.Fragment>
      <Layout.Divider />
      <Layout.FullWidth fold>
        <Layout.FullWidthColumn spaced>
          <UI.Heading>Flash Contest Winners</UI.Heading>
        </Layout.FullWidthColumn>
        <Carousel flashContests={flashContests} timezone={sweepstakes.timezone} />
      </Layout.FullWidth>
    </React.Fragment>
  );
};

export default FlashContestWinnerSection;
